import {
    SmallTextHelper,
    UrlHelper,

} from '../PrismicHelpers';

export const courseListHelper = (response) => {

    const courseData = response.result;

    let courseObject = courseData.map(course => {
        return {
            uid: SmallTextHelper(course.id),
            date: SmallTextHelper(course.data.date),
            image: UrlHelper(course.data.course_image),
            name: SmallTextHelper(course.data.course_name),
            description: SmallTextHelper(course.data.course_description),
            trailer_url: SmallTextHelper(course.data.trailer_url),
            region: SmallTextHelper(course.data.course_region),
            external_link: SmallTextHelper(course.data.external_worksheet_link),
            show_cpd: SmallTextHelper(course.data.show_cpd)     
        }
    })
    return courseObject;
}


// WEBPACK FOOTER //
// src/client/helpers/prismicHelpers/prismic-custom-helpers/CourseHelpers.js